var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center"},[_vm._v(" "+_vm._s(_vm.params.value[0].Longeur)+"/"+_vm._s(_vm.params.value[0].Nez)+"/"+_vm._s(_vm.params.value[0].Hauteur)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }